"use client";

import type { OpportunityTemplate } from "@/lib/types";

type Props = {
  templates: OpportunityTemplate[];
  activeTemplate: string | null;
  onSelectTemplate: (templateId: string | null) => void;
};

export function TemplateCards({ templates, activeTemplate, onSelectTemplate }: Props) {
  if (templates.length === 0) return null;

  return (
    <section className="template-grid">
      {templates.map((template) => (
        <button
          key={template.id}
          type="button"
          className={`template-card ${activeTemplate === template.id ? "template-card--active" : ""}`}
          onClick={() => onSelectTemplate(activeTemplate === template.id ? null : template.id)}
        >
          <p className="template-card-title">{template.title}</p>
          <p className="template-card-desc">{template.description}</p>
          <p className="template-card-meta">
            {template.niches.length > 0
              ? template.niches.slice(0, 3).map((niche) => niche.label).join(", ")
              : "No niches match right now"}
          </p>
        </button>
      ))}
    </section>
  );
}
